import { render } from "./JobIcons.vue?vue&type=template&id=3522a35c&scoped=true"
import script from "./JobIcons.vue?vue&type=script&lang=js"
export * from "./JobIcons.vue?vue&type=script&lang=js"

import "./JobIcons.vue?vue&type=style&index=0&id=3522a35c&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522a35c"]])

export default __exports__